import React, { useState } from "react";
import Logo from "../assets/favicon.jpeg";
import { ArrowLeft, Mail } from "lucide-react";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Support: React.FC = () => {
  const [email, setEmail] = useState("");
  const [messageText, setMessageText] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!email.trim()) return setError("Email is required.");
    if (!emailRegex.test(email)) return setError("Enter a valid email.");
    if (!messageText.trim()) return setError("Please enter your message.");

    try {
      setLoading(true);

      // 🔹 OPTION 1: Open email client (no backend)
      window.location.href = `mailto:support@jacscanpaygo.co.za?subject=Support Request&body=${encodeURIComponent(
        messageText + "\n\nFrom: " + email
      )}`;

      setSuccess("Opening your email client...");
      setEmail("");
      setMessageText("");

      // 🔹 OPTION 2 (later): send to backend
      // await fetch(`${API_BASE}/api/support`, {...})

    } catch {
      setError("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8f7f5", padding: 16, fontFamily: "'DM Sans', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap');`}</style>

      <div style={{ width: 400, maxWidth: "100%" }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <img src={Logo} alt="JAC Logo" style={{ width: 64, height: 64, borderRadius: "16px", objectFit: "cover", marginBottom: "14px" }} />
          <h1 style={{ margin: 0, fontSize: "22px", fontWeight: 600, color: "#111827" }}>Scan Pay Go</h1>
          <p style={{ margin: "4px 0 0", fontSize: "14px", color: "#9ca3af" }}>Support</p>
        </div>

        {/* Card */}
        <div style={{ background: "#fff", borderRadius: "20px", padding: "32px", border: "1px solid #f3f4f6", boxShadow: "0 4px 24px rgba(0,0,0,0.06)" }}>

          {/* Icon */}
          <div style={{ width: "48px", height: "48px", borderRadius: "14px", background: "#fff5f2", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "20px" }}>
            <Mail size={22} color="#F1561D" />
          </div>

          <h2 style={{ margin: "0 0 8px", fontSize: "18px", fontWeight: 600, color: "#111827" }}>
            Contact Support
          </h2>

          <p style={{ margin: "0 0 24px", fontSize: "14px", color: "#9ca3af", lineHeight: 1.5 }}>
            Send us a message and we’ll get back to you as soon as possible.
          </p>

          {error && (
            <div style={{ marginBottom: "16px", padding: "12px 14px", borderRadius: "10px", background: "#fff5f5", border: "1px solid #fecaca", fontSize: "13px", color: "#b91c1c" }}>
              {error}
            </div>
          )}

          {success && (
            <div style={{ marginBottom: "16px", padding: "12px 14px", borderRadius: "10px", background: "#f0fdf4", border: "1px solid #bbf7d0", fontSize: "13px", color: "#166534" }}>
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            
            {/* Email */}
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: 500, color: "#374151", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "6px" }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
                style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: "10px", padding: "10px 14px", fontSize: "14px", background: "#fafafa" }}
              />
            </div>

            {/* Message */}
            <div>
              <label style={{ display: "block", fontSize: "12px", fontWeight: 500, color: "#374151", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "6px" }}>
                Message
              </label>
              <textarea
                value={messageText}
                onChange={e => setMessageText(e.target.value)}
                placeholder="Describe your issue..."
                rows={4}
                style={{ width: "100%", border: "1px solid #e5e7eb", borderRadius: "10px", padding: "10px 14px", fontSize: "14px", background: "#fafafa", resize: "none" }}
              />
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              style={{ height: "44px", borderRadius: "10px", border: "none", background: loading ? "#fdba99" : "#F1561D", color: "#fff", fontSize: "15px", fontWeight: 600 }}
            >
              {loading ? "Opening…" : "Send Message"}
            </button>
          </form>

          {/* Direct email fallback */}
          <div style={{ marginTop: "16px", textAlign: "center", fontSize: "13px", color: "#6b7280" }}>
            Or email us directly at{" "}
            <a href="mailto:support@jacscanpaygo.co.za" style={{ color: "#F1561D", textDecoration: "none", fontWeight: 500 }}>
              support@jacscanpaygo.co.za
            </a>
          </div>

          {/* Back */}
          <div style={{ marginTop: "24px", textAlign: "center" }}>
            <a href="/" style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px", color: "#6b7280", textDecoration: "none", fontWeight: 500 }}>
              <ArrowLeft size={14} /> Back to home
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Support;